import { render, staticRenderFns } from "./alogin2.vue?vue&type=template&id=600a2924&scoped=true"
import script from "./alogin2.vue?vue&type=script&lang=js"
export * from "./alogin2.vue?vue&type=script&lang=js"
import style0 from "./alogin2.vue?vue&type=style&index=0&id=600a2924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600a2924",
  null
  
)

export default component.exports